/* eslint-disable no-restricted-globals */
import _ from 'lodash';
import { updateOptionCategory } from '../../apis/backend';
import { ERROR_UPDATE_PRODUCT_OPTION, ERROR_WRONG_INFORMATIONS, ERROR_SYNCHRONIZATION_WITH_SHOP } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { isStringNotNull, keyGenerator } from '../../utils/tools';
import { checkIntegrationAccess } from 'src/utils/externalIntegration';


export const updateCategory = ({ target }, component) => {
  component.setState(prevState => {
    const { category } = prevState;
    const { min, max, optionFree } = category;
    const parsedValue = parseInt(target.value, 10);

    const newCategory = {
      ...category,
      [target.id || target.name]: (target.id === 'name' || target.id === 'type') ? target.value : parsedValue,
      multiple: (min <= 1 && max === 1) ? false : category.multiple,
      optionFree: target.id === 'optionFree' ? parsedValue : optionFree,
    };

    if (target.id === 'min' && parsedValue > max) {
      newCategory.max = parsedValue;
    } else if (target.id === 'max' && parsedValue < optionFree) {
      newCategory.optionFree = 0;
    }

    return { category: newCategory };
  });
};


export const checkMinValue = ({ target }, component, min) => {
  let { value = '' } = target;
  value = parseInt(value, 10);
  if (value < min) {
    target.value = min;
  }
  updateCategory({ target }, component);
}

export const updateRadioButton = ({ target }, component) => {
  component.setState(prevState => {
    const { category } = prevState;
    return {
      category: { ...category, [target.id || target.name]: target.value }
    };
  });
};
export const handleUpdateCategorie = async (component, shopsMenu) => {
  const { openErrorModal, closeModal } = component.props;
  try {
    component.setState({ isLoading: true });
    const { category, synchronize = false } = component.state;
    const { categories } = component.props;
    const {
      max,
      min,
      key = keyGenerator('OPTION'),
      name,
      multiple = false,
      items = null,
      type,
      optionFree
    } = category;

    const nameToCkeck = name ? name.replace(/\s+/g, '') : '';
    if (nameToCkeck && nameToCkeck.length > 0 && (checkIntegrationAccess('products', 'hasMenuPOS') ? isStringNotNull(type) : true)) {
      const returnCategory = {
        ...category,
        multiple: JSON.parse(multiple),
        min,
        max: category.max || null,
        position: _.keys(categories).length,
        key,
        items,
        type,
        optionFree: max === 1 ? null : optionFree
      };
      if (!synchronize || (synchronize && _.size(shopsMenu) > 1)) {
        await updateOptionCategory(returnCategory, synchronize, shopsMenu);

        closeModal();
        component.setState({ showModal: false, synchronize: false });
      }
      else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoading: false }) };
    } else {
      openErrorModal(ERROR_WRONG_INFORMATIONS);
    }
  } catch (error) {
    sendCloudWatchAlert(`Error updating product option  ${error}`);
    openErrorModal(ERROR_UPDATE_PRODUCT_OPTION);
  }
  component.setState({ isLoading: false });
};